import { Route, Routes } from 'react-router-dom';
import ErrorBoundary from './components/common/ErrorBoundary';
import HomePage from './pages/HomePage';
import PrivacyPage from './pages/PrivacyPage';
import CscLivePage from './pages/CscLivePage';

function App() {
  return (
    <ErrorBoundary>
      <div className="min-h-screen bg-white">
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/contact" element={<HomePage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/csc-live" element={<CscLivePage />} />
          {/* <Route path="/case-studies" element={<HomePage />} /> */}
        </Routes>
      </div>
    </ErrorBoundary>
  );
}

export default App;
